import Routes from "routing/Routes";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const entityCreatorBindings = {
  "entityCreators": [
    {
      id: "Event Definition",
      title: "Create event definition",
      path: Routes.ALERTS.DEFINITIONS.CREATE,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.EVENTDEFINITION_CREATE_BUTTON_CLICKED,
        section: "event-definitions",
        actionValue: "create-event-definition-button"
      },
      permissions: "eventdefinitions:create"
    },
    {
      id: "Event Notification",
      title: "Create notification",
      path: Routes.ALERTS.NOTIFICATIONS.CREATE,
      permissions: "eventnotifications:create"
    },
    {
      id: "Dashboard",
      title: "\u65B0\u5EFA\u4EEA\u8868\u76D8",
      path: Routes.DASHBOARD.NEW,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.DASHBOARD_ACTION.DASHBOARD_CREATE_CLICKED,
        section: "dashboard",
        actionValue: "dashboard-create-button"
      },
      permissions: "dashboards:create"
    },
    {
      id: "Stream",
      title: "\u65B0\u5EFA\u65E5\u5FD7\u6D41",
      path: Routes.STREAM_NEW,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.STREAMS.CREATE_FORM_MODAL_OPENED,
        section: "streams",
        actionValue: "create-stream-button"
      },
      permissions: "streams:create"
    },
    {
      id: "Index Set",
      title: "\u65B0\u5EFA\u7D22\u5F15\u96C6",
      path: Routes.SYSTEM.INDEX_SETS.CREATE,
      permissions: "indexsets:create"
    },
    {
      id: "User",
      title: "\u65B0\u5EFA\u7528\u6237",
      path: Routes.SYSTEM.USERS.CREATE,
      permissions: "users:create"
    },
    {
      id: "Pipeline",
      title: "Create pipeline",
      path: Routes.SYSTEM.PIPELINES.CREATE,
      permissions: "pipeline:create"
    },
    {
      id: "Pipeline Rule",
      title: "Create pipeline rule",
      path: Routes.SYSTEM.PIPELINES.RULE("new?rule_builder=true"),
      permissions: "pipeline:create",
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.PIPELINE_RULE_BUILDER.CREATE_RULE_CLICKED,
        section: "pipeline-rules",
        actionValue: "create-rule-button"
      }
    },
    {
      id: "Content Pack",
      title: "Create content pack",
      path: Routes.SYSTEM.CONTENTPACKS.CREATE
    }
  ]
};
export default entityCreatorBindings;
